<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="510px"
    custom-class="find-password-dialog"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
  >
    <section class="find-password-panel">
      <h2 class="find-password-title">找回密码</h2>

      <el-form
        ref="findForm"
        :model="findForm"
        :rules="findRules"
        class="find-password-form"
      >
        <el-form-item prop="phoneNumber">
          <el-input
            v-model="findForm.phoneNumber"
            auto-complete="new-password"
            type="text"
            placeholder="请输入您的手机号"
          ></el-input>
        </el-form-item>

        <!-- 图形验证码 -->
        <el-form-item v-if="captchaEnabled" prop="code" class="combined-form-item">
          <el-input
            v-model="findForm.code"
            auto-complete="new-password"
            placeholder="验证码"
          ></el-input>
          <button class="captcha-button" type="button" title="点击刷新验证码" @click="getCode">
            <img :src="codeUrl" alt="图形验证码" />
          </button>
        </el-form-item>

        <!-- 短信验证码 -->
        <el-form-item prop="smsCode" class="combined-form-item sms-code-item">
          <el-input
            v-model="findForm.smsCode"
            auto-complete="new-password"
            placeholder="请输入获取的验证码"
          ></el-input>
          <el-button
            v-if="show"
            class="sms-code-button"
            @click="sendCode"
          >
            获取短信验证码
          </el-button>
          <el-button
            v-else
            class="sms-code-button"
            :disabled="isdisabled"
          >
            {{ count }}S
          </el-button>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="findForm.password"
            auto-complete="new-password"
            type="password"
            placeholder="请输入您的新密码"
          ></el-input>
        </el-form-item>

        <el-form-item prop="passwordConfirm">
          <el-input
            key="find-pwdconfirm"
            v-model="findForm.passwordConfirm"
            auto-complete="new-password"
            type="password"
            placeholder="请再次确认您的新密码"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="find-password-submit" @click="submitHandle">提交</div>
      <div class="back-login-button" @click="cancel">返回登录</div>
    </section>
  </el-dialog>
</template>
  <script>
  import { getCodeImg, sendPwdCode, findPassword } from "@/api/request";
  import { isMobile } from "@/plugins/validate";
  export default {
    data() {
      var validateMobile = (rule, value, callback) => {
        if (value && !isMobile(value)) {
          return callback(new Error("请输入正确的手机号"));
        }
        callback();
      };
      return {
        dialogVisible: false,
        // 验证码开关
        captchaEnabled: true,
        codeUrl: '',
        findForm: {
          phoneNumber: "",
          code: "",
          smsCode: '',
          password: '',
          passwordConfirm: ''
        },
        show: true,
        isdisabled: false,
        count: "",
        timer: null,
        findRules: {
          phoneNumber: [
            { required: true, trigger: "blur", message: "请输入手机号" },
            { validator: validateMobile, trigger: "blur" }
          ],
          code: [{ required: true, trigger: "blur", message: "请输入验证码" }],
          smsCode: [{ required: true, trigger: "blur", message: "请输入验证码" }],
          password: [{ required: true, trigger: "blur", message: "请输入密码" }],
          passwordConfirm: [{ required: true, trigger: "blur", message: "请输入密码" }]
        },
      };
    },
    methods: {
      init() {
        this.dialogVisible = true;
        this.getCode()
      },
      getCode(){
        getCodeImg().then(res => {
          this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled
          if (this.captchaEnabled) {
            this.codeUrl = "data:image/gif;base64," + res.img
            this.findForm.uuid = res.uuid
          }
        })
      },
      //关闭dialog之前清空表单
      clearFindForm() {
        this.$nextTick(() => {
          this.$refs.findForm.resetFields()
        })
      },
      cancel () {
        this.dialogVisible = false;
        this.$emit('cancel')
        // clearInterval(this.qrCodeData.checkLoginTimer);
      },
      submitHandle() {
        //   this.loginForm.password = undefined
          this.$refs.findForm.validate(valid => {
            if (valid) {
                // if(this.findForm.password)
                const regex = /^[A-Za-z0-9]{6,15}$/;
                let flag = regex.test(this.findForm.password)
                if(flag){
                    if(this.findForm.password === this.findForm.passwordConfirm){
                        findPassword(this.findForm).then(res => {
                            this.$refs["findForm"].resetFields();
                            this.$message.success("修改成功，请重新登录");
                            this.cancel()
                        }).catch(err => {
                            this.$message.error('验证码失效请重新提交');
                            this.getCode()
                        })
                    }else{
                        this.$message.warning('两次输入的密码不一致');
                    }
                }else{
                    this.$message.warning('密码需为6-15位，包含数字+字母，不含特殊符号');
                }
            }
          });
        
      },
      //获取验证码
      sendCode() {
        if (this.findForm.phoneNumber == "") {
          return this.$message.error("请输入手机号");
        }
        if (!isMobile(this.findForm.phoneNumber)) {
          return false
        }
        sendPwdCode({ phoneNumber: this.findForm.phoneNumber }).then(res => {
          if (res.code == 200) {
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.isdisabled = false;
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        });
      },

    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  };
  </script>
  <style lang="scss">
.find-password-dialog {
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 12px 28px rgba(44, 57, 75, 0.14);
}
.find-password-dialog .el-dialog__header {
  display: none;
}
.find-password-dialog .el-dialog__body {
  padding: 0;
}
.find-password-panel {
  box-sizing: border-box;
  max-height: calc(100vh - 40px);
  padding: 42px 42px 34px;
  overflow-y: auto;
  color: #52647f;
  background: #fff;
}
.find-password-title {
  margin: 0 0 32px;
  color: #5CC300;
  font-size: 28px;
  font-weight: 400;
  line-height: 36px;
  text-align: center;
}
.find-password-form .el-form-item {
  margin-bottom: 20px;
}
.find-password-form .el-input__inner {
  height: 48px;
  padding: 0 16px;
  border-color: #d8e0ea;
  border-radius: 7px;
  color: #52647f;
  font-size: 17px;
}
.find-password-form .el-input__inner:focus {
  border-color: #5CC300;
}
.combined-form-item .el-form-item__content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 127px;
  gap: 12px;
}
.combined-form-item .el-form-item__content::before,
.combined-form-item .el-form-item__content::after {
  display: none;
}
.combined-form-item .el-input {
  grid-row: 1;
  grid-column: 1;
}
.captcha-button,
.sms-code-button {
  grid-row: 1;
  grid-column: 2;
  box-sizing: border-box;
  width: 127px;
  height: 48px;
  padding: 0;
  border-radius: 6px;
}
.captcha-button {
  overflow: hidden;
  cursor: pointer;
  background: #e4e7ed;
  border: 0;
}
.captcha-button img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.sms-code-button {
  color: #5CC300;
  border-color: #5CC300;
  font-size: 16px;
}
.sms-code-button:hover,
.sms-code-button:focus {
  color: #36b9b3;
  background: #f2fbfa;
  border-color: #36b9b3;
}
.find-password-submit {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  font-weight: 600;
  background: linear-gradient(to right, #9FFFD7, #BAFF75);
}
.back-login-button {
  cursor: default;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-top: 15px;
  font-weight: 600;
  border: 1px solid #cccccc;
}
.find-password-dialog  {
  cursor: default;
  display: block;
  margin: 18px auto 0;
  color: #5CC300;
  font-size: 16px;
}
@media (max-width: 540px) {
  .find-password-dialog {
    width: calc(100% - 28px) !important;
    margin-top: 20px !important;
  }
  .find-password-panel {
    padding: 30px 24px 26px;
  }
  .find-password-title {
    margin-bottom: 24px;
    font-size: 24px;
  }
  .combined-form-item .el-form-item__content {
    grid-template-columns: minmax(0, 1fr) 118px;
    gap: 10px;
  }
  .captcha-button,
  .sms-code-button {
    width: 118px;
  }
}
</style>
